module.exports = __webpack_public_path__ + "assets/waiting.7d1743d11bc03d1ab6dc3aead14bc934.svg";